<template>
    <VStepperContent v-bind="$attrs" :step="step" v-on="$listeners">
        <div class="mb-4">
            <h2 v-if="title" class="brand-blue--text" v-text="title" />
        </div>
        <slot />
    </VStepperContent>
</template>

<script>
export default {
    name: 'SrModalStep',
    props: {
        /**
         * Sets step to associate the content to
         */
        step: {
            type: [Number, String],
            required: true,
        },
        /**
         * Content title
         */
        title: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>
